import {doSuccessFailureActions} from '../_utils/actions.js';

export const LOGIN = doSuccessFailureActions('LOGIN');
export const LOGOUT = 'LOGOUT';
export const MODIFY_API_TOKEN = doSuccessFailureActions('MODIFY_API_TOKEN');

export function login(username) {
  return {type: LOGIN.do, username};
}

export function loginSuccess(infos) {
  return {type: LOGIN.success, infos};
}

export function loginFailure(err) {
  return {type: LOGIN.failure, err};
}

export function logout() {
  return {type: LOGOUT};
}

export function modifyApiToken(userId, oldToken, newToken) {
  return {
    type: MODIFY_API_TOKEN.do,
    userId,
    newToken,
    oldToken
  };
}

export function modifyApiTokenSuccess(newToken) {
  return {
    type: MODIFY_API_TOKEN.success,
    newToken
  };
}

export function modifyApiTokenFailure(err) {
  return {
    type: MODIFY_API_TOKEN.failure,
    err
  };
}



// WEBPACK FOOTER //
// ./src/redux/user/actions.js